import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Observable} from 'rxjs';
import {Step} from '../models/step';
import {ServicePathsSettings} from '../../../../core/configuration/service-paths-settings';
import {FascicoloTemp} from '../models/fascicolo-temp';

@Injectable({
  providedIn: 'root'
})
export class CreazionePraticaService {

  constructor(private http: HttpClient) {
  }

  getStepList(): Observable<{ steps: Step[] }> {
    return this.http.get<{ steps: Step[] }>(ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_FETCH_STEP_WIZARD_PRTICA);
  }

  updateFascicoloTemp(req: FascicoloTemp, idElaborazione: string): Observable<FascicoloTemp> {
    return this.http.put<FascicoloTemp>(ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_ELABORATION_FASCICOLO_TEMP(idElaborazione), req);
  }

  updateFascicoloTempPDA(req: FascicoloTemp, idElaborazione: string): Observable<FascicoloTemp> {
    return this.http.put<FascicoloTemp>(ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_ELABORATION_FASCICOLO_TEMP_PDA(idElaborazione), req);
  }

  deleteFascicoloTemp(idElaborazione: string): Observable<FascicoloTemp> {
    return this.http.delete<FascicoloTemp>(ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_ELABORATION_FASCICOLO_TEMP(idElaborazione));
  }

  completaFascicoloTemp(req: FascicoloTemp, idElaborazione: string) {
    return this.http.post(ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_ELABORATION_FASCICOLO_TEMP(idElaborazione), req);
  }

  completaFascicoloTempPDA(req: FascicoloTemp, idElaborazione: string) {
    return this.http.post(ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_ELABORATION_FASCICOLO_TEMP_PDA(idElaborazione), req);
  }


  getFascicoloTemp(idElaborazione: string): Observable<FascicoloTemp> {
    return this.http.get<FascicoloTemp>(ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_ELABORATION_FASCICOLO_TEMP(idElaborazione));
  }

  associaFascicolo(idElaborazione: string, idFascicolo: string): Observable<any> {
    return this.http.put(ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_ASSOCIA_FASCICOLO(idElaborazione, idFascicolo), null);
  }

  createFascicoloPct(req: FascicoloTemp, idFascicolo: string, registro: string): Observable<any> {
    return this.http.post(ServicePathsSettings.URL_CREATE_FASCICOLO_PCT(idFascicolo, registro), req)
  }
}
